import React, {useMemo, useState, useEffect, memo, MouseEvent} from 'react';
import cx from 'classnames';

import styles from './index.less';

interface IImport {
    [key: string]: any;
    default?: Record<string, any>;
}

interface ISvg {
    /**
     * icon名称，即文件名
     */
    name: string;
    /**
     * 自定义类名
     */
    className?: string;
    /**
     * 宽度
     */
    width?: number;
    /**
     * 高度
     */
    height?: number;
    /**
     * 颜色
     */
    color?: string;
    /**
     * 自定义样式
     */
    style?: React.CSSProperties;

    /**
     * 点击事件
     */
    onClick?: (e: MouseEvent) => void;
}

const SvgIcon: React.FC<ISvg> = props => {
    const {
        name,
        className = '',
        width,
        height,
        color,
        style = {},
        onClick,
    } = props;
    const [svgModule, setSvgModule] = useState<IImport>();

    // const getSvg = useCallback(
    //     async (name) => {
    //         return await import(`@/assets/svg/icons/${name}.svg`);
    //     },
    //     []
    // );

    const iconPath = useMemo(
        () => {
            if (svgModule && svgModule.default) {
                return `#${svgModule.default.id}`;
            }
        },
        [svgModule]
    );

    const nextStyle: React.CSSProperties = {...style};

    width && (nextStyle.width = `${width}px`);
    height && (nextStyle.height = `${height}px`);
    color && (nextStyle.color = color);

    useEffect(
        () => {
            import(`@/assets/svg/icons/${name}.svg`).then(svg => {
                setSvgModule(svg);
            });
        },
        [name]
    );

    return (
        <svg
            onClick={onClick}
            style={nextStyle}
            className={cx(styles.svgIcon, className)}
            aria-hidden="true"
        >
            <use xlinkHref={iconPath} />
        </svg>
    );
};

export default memo(SvgIcon);
